<template>
  <div v-if="storeInfo" class="main">
    <LinkTitle></LinkTitle>
    <div class="conatainer">
      <PageSearchTitle title="店铺" :showCart="false" />
      <div class="box">
        <div class="title">
          <div class="storeInfoTilteLeft">
            <div>店铺：{{ storeInfo.s_name }}</div>
            <el-divider class="divider" direction="vertical"></el-divider>
            <div class="storeInfoTilteLeftImgBox">
              店铺等级：
              <i
                v-for="(item, index) in storeInfo.s_grade || 1"
                :key="index"
                class="el-icon-medal"
              ></i>
            </div>
            <el-divider class="divider" direction="vertical"></el-divider>
            <el-button type="text" class="PrepayRecharge" @click="dialogVisible = true">
              预付款
              <i class="el-icon-s-order"></i>
            </el-button>
            <el-dialog
              title="预付款充值"
              :visible.sync="dialogVisible"
              width="30%"
              :close-on-click-modal="false"
              :show-close="false"
            >
              <el-radio-group v-model="selectLock">
                <el-radio :label="0">本次解锁</el-radio>
                <el-radio :label="1">不解锁</el-radio>
                <el-radio :label="2">自动解锁</el-radio>
              </el-radio-group>
              <div class="dialogStore">
                {{ storeInfo.s_name }}
                <button @click="toprepayRecharge">预付款详情</button>
              </div>
              <el-input
                placeholder="请输入充值金额"
                v-model="rechargeInput"
                onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)"
                onafterpaste="this.value=this.value.match(/\d+\.?\d{0,2}/)"
              >
                <template slot="prepend">预付款充值额度 :</template>
                <template slot="append">元</template>
              </el-input>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleCancel">取 消</el-button>
                <el-button type="primary" @click="RechangeMoney">确 定</el-button>
              </span>
            </el-dialog>

            <el-divider v-if="isBeijing" class="divider" direction="vertical"></el-divider>
            <div v-if="isBeijing">开店时间：{{ timer(storeInfo.createTime).format("YYYY-MM-DD") }}</div>

            <el-divider v-if="storeInfo.contacts_name" class="divider" direction="vertical"></el-divider>
            <div v-if="storeInfo.contacts_name">业务联系人：{{ storeInfo.contacts_name }}</div>

            <el-divider v-if="storeInfo.mobile_id" class="divider" direction="vertical"></el-divider>
            <div v-if="storeInfo.mobile_id">联系人电话：{{ formateMobile(storeInfo.mobile_id) }}</div>
          </div>
          <div @click="clectionStore" class="storeInfoTilteRight">
            <i
              :class="[
                flag ? 'el-icon-star-on' : 'el-icon-star-off',
                'textHover',
              ]"
            >
              <span class="iconText">
                {{
                flag ? "取消关注" : "关注店铺"
                }}
              </span>
            </i>
          </div>
        </div>
      </div>
      <div class="storeMain">
        <div class="storeMainLeft">
          <div class="storeMainLeftTop">
            <div class="storeMainLeftImgBox">
              <el-image
                style="width: 50px; height: 50px"
                :src="getImageUrl(storeInfo.s_headImg)"
                fit="cover"
              ></el-image>
            </div>
            <div>
              <div class="storeMainLeftTopText">{{ storeInfo.s_name }}</div>
              <div class="storeMainLeftTopText2">{{ count }}人关注</div>
            </div>
          </div>
          <div class="split_h"></div>
          <div>
            <div class="introduction">
              店铺简介
              <div class="introductionText">{{ storeInfo.introduction || "暂未填写" }}</div>
            </div>
            <div class="split_h"></div>
            <div class="introduction">
              所属公司
              <div class="introductionText">{{ storeInfo.companyName || "暂未填写" }}</div>
            </div>
            <div class="split_h"></div>
            <div class="introduction">
              店铺地址
              <div class="introductionText">{{ storeInfo.address || "暂未填写" }}</div>
            </div>
            <!-- <div class='split_h'></div>
            <div class="introduction">
              店铺联系人
              <div class="introductionText">
                {{ storeInfo.contacts_name || "暂未填写" }}
              </div>
            </div>
               <div class='split_h'></div>
            <div class="introduction">
              联系人电话
              <div class="introductionText">
                {{ storeInfo.mobile_id || "暂未填写" }}
              </div>
            </div>-->
          </div>
        </div>
        <div class="storeMainRight">
          <div
            v-for="(item, index) in goods"
            @click="() => toGoodsDetail(item)"
            :key="index"
            class="goodsItem"
          >
            <el-image
              style="width: 160px; height: 180px"
              :src="getImageUrl(item.coverPlan)"
              fit="cover"
            ></el-image>
            <div class="goodsName">{{ item.name }}</div>
            <div class="goodsBottomBox">
              <div>{{ item.price }}/{{ item.unit }}</div>
              <div class="buyBtn">购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import {
  queryStoreDateUrl,
  getImageUrl,
  getGoodsUrl,
  storeAttentUrl,
  queryCompanyGetUrl,
  isBeijing,
  addPrepay,
  isNewRechargeUser
} from "@/api/api";

import { mapState } from "vuex";
import timer from "time-formater";
export default {
  name: "storeHomePage",
  data() {
    return {
      storeInfo: null,
      goodsAvgScore: "",
      serviceAvgScore: "",
      timeAvScore: "",
      bannerList: [],
      goods: [],
      selectLock: 0,
      input2: "",
      rechargeInput: "",
      storeId: "",
      dialogVisible: false,
      count: "", //关注数
      flag: false, //当前登录用户是否关注此店铺
      company: null
    };
  },
  created() {
    this.getImageUrl = getImageUrl;
    this.timer = timer;
    this.isBeijing = isBeijing;
  },
  mounted() {
    this.getStoreInfo();
    this.getGoodsList();
  },
  watch: {
    "$route.query": function() {
      this.getStoreInfo();
      this.getGoodsList();
    }
  },
  computed: {
    ...mapState(["userInfo"])
  },
  components: {
    PageSearchTitle
  },
  methods: {
    formateMobile(data) {
      let value = "";
      if (this.userInfo && this.userInfo.access_token) {
        value = data;
      } else {
        value = data.substr(0, 3) + "****" + data.substr(7, 4);
      }
      return value;
    },
    clectionStore() {
      this.$checkLogin(this.userInfo)
        .then(() => {
          let url = storeAttentUrl;
          let data = {
            access_token: this.userInfo.access_token,
            storeId: this.$route.query.store_id
          };
          let param = new URLSearchParams();
          for (var k in data) {
            param.append(k, data[k]);
          }
          this.$axios({
            method: "post",
            data: param,
            url
          })
            .then(res => {
              if (res.data.resultCode == 1) {
                this.getStoreInfo();
              } else {
                this.$alert(res.data.resultMsg);
              }
            })
            .catch(err => {
              this.$alert(JSON.stringify(err));
            });
        })
        .catch(e => {
          this.$router.push({ path: "/login" });
        });
    },
    toGoodsDetail(item) {
      this.$router.push({
        name: "goodsDetail",
        query: { goodsId: item.id, type: -1 }
      });
    },
    getGoodsList() {
      console.log(this.$route.query.store_id);
      let url = getGoodsUrl;
      let data = {
        storeId: this.$route.query.store_id,
        pageSize: 9999,
        pageIndex: 0,
        status: 1
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            this.goods = JSON.parse(JSON.stringify(data));
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(JSON.stringify(err));
        });
    },
    toprepayRecharge() {
      this.$router.push({ name: "prepayRecharge" });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.rechargeInput = "";
        })
        .catch(_ => {});
    },
    RechangeMoney() {
      if (this.rechargeInput > 0) {
        let access_token = this.userInfo.access_token;
        let url = addPrepay;
        let data = {
          access_token,
          store_id: this.$route.query.store_id,
          money: this.rechargeInput,
          isLock: this.selectLock
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url
        })
          .then(res => {
            if (res.data.resultCode == 1) {
              let { data } = res.data;
              console.log("dataf", data);
              let id = data.id;
              let order_id = data.order_id;
              let totalMoney = data.totalMoney;
              let prepayment = data.prepayment;
              let type = data.type;
              let fm_status = data.fm_status;
              let pay_flag = data.pay_flag;
              let store_name = data.store_name;
              let store_id = data.store_id;
              this.$router.push({
                name: "payPage",
                query: {
                  id,
                  order_id,
                  totalMoney,
                  prepayment,
                  type,
                  fm_status,
                  pay_flag,
                  store_name,
                  store_id
                }
              });
            } else {
              this.$alert(res.data.resultMsg);
            }
          })
          .catch(err => {
            // this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
          });
        console.log("mckmkmc");
        // this.dialogVisiblere=false;
      } else {
        this.$alert("充值金额无效");
      }
    },
    dialogVisibleCancel() {
      this.dialogVisible = false;
      this.rechargeInput = "";
    },
    getStoreInfo() {
      console.log(this.$route.query.store_id);
      let url = queryStoreDateUrl;
      let data = {
        access_token:
          this.userInfo && this.userInfo.access_token
            ? this.userInfo.access_token
            : "",
        storeId: this.$route.query.store_id
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            this.storeInfo = JSON.parse(JSON.stringify(data));
            this.bannerList = res.data.data2 || [];
            this.count = res.data.count || 0; //关注数
            this.flag = res.data.flag;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(JSON.stringify(err));
        });
    }
  }
};
</script>

<style scoped lang='less'>
.main {
  background-color: #f6f6f6;
}
@media screen and(min-width:320px) and(max-width:1000px) {
  .conatainer {
    margin: 5px 10px 0 !important;
  }
}
.conatainer {
  margin: 5px 150px 0;
}
.PrepayRecharge {
  display: flex;
  flex-direction: row;
  align-items: center;
  i {
    color: #409eff;
    margin-left: 4px;
  }
}
.box {
  margin-top: 20px;
}
.tabsBox {
  width: 100%;
}
.title {
  color: #454545;
  font-size: 13px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.gradeImg {
  width: 20px;
  height: 20px;
}
.storeInfoTilteLeft {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  color: #454545;
  align-items: center;
}
.storeInfoTilteLeftImgBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.divider {
  background-color: #bbb;
}
.storeMain {
  margin-top: 20px;
  // background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  width: 100%;
}
.storeMainLeft {
  max-width: 200px;
  max-height: 600px;

  margin-right: 20px;
  border: 1px dashed #009e96;
  background-color: #fff;
  padding: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.storeMainRight {
  min-height: 300px;
  flex: 1;
  background-color: #fff;
}
.storeMainLeftImgBox {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 10px;
}
.storeMainLeftTop {
  flex-direction: row;
  display: flex;
  align-items: center;
}
.storeMainLeftTopText {
  font-size: 12px;
  color: #454545;
}
.storeMainLeftTopText2 {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
}
.introduction {
  font-size: 13px;
  color: #333;
  margin-top: 10px;
}
.introductionText {
  margin-top: 5px;
  padding-left: 15px;
  font-size: 12px;
  color: #666;
}
.storeMainRight {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.goodsItem {
  background-color: #f6f6f6;
  margin: 10px;
  font-size: 12px;
  color: #454545;
  padding: 10px;
  width: 160px;
  max-height: 260px;
}
.goodsItem {
  cursor: pointer;
}
.goodsName {
  margin-top: 10px;
  margin-bottom: 10px;
  max-height: 40px;
}
.goodsBottomBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.buyBtn {
  width: 40px;
  height: 20px;
  background-color: #f60;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
}
.buyBtn:hover {
  cursor: pointer;
}
.storeInfoTilteRight {
  font-size: 13px;
  color: #f60;
}
.el-icon-star-on {
  color: #888;
  font-size: 15px;
  line-height: 15px;
}
.iconText {
  margin-left: 3px;
  font-size: 12px;
  line-height: 15px;
}
.el-icon-medal {
  color: #409eff;
}
.dialogStore {
  margin-top: 20px;
  margin-bottom: 20px;
  button {
    float: right;
    color: #409eff;
    margin-right: 30px;
    margin-top: 3px;
    background-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/StoreHomePage.vue